import { Link } from "react-router-dom";
import { NavLink } from "react-router-dom";

const SubDrawer = ({
  activeDrawerOverlay,
  setActiveDrawerOverlay,
  subCategoriesLoading,
  subCategoriesError,
  fetchSubCategories,
  subCategories,
  closeDrawer,
  staticProfileOptions,
  setShowLogoutModal,
}) => {
  return (
    <div
      className={`mobile-menu-drawer__submenu ${
        activeDrawerOverlay ? "is-open" : ""
      }`}
      aria-hidden={!activeDrawerOverlay}
    >
      <div className="mobile-menu-drawer__submenu-head">
        <button
          type="button"
          className="mobile-menu-drawer__submenu-back"
          onClick={() => setActiveDrawerOverlay("")}
        >
          <i className="ph ph-caret-left" />
          <span>Back</span>
        </button>
        <h6 className="mobile-menu-drawer__submenu-title">
          Explore {activeDrawerOverlay}
        </h6>
      </div>
      {activeDrawerOverlay === "Categories" ? (
        <div className="mobile-menu-drawer__submenu-list">
          {subCategoriesLoading ? (
            <div className="mobile-menu-drawer__submenu-state">
              <i className="ph ph-circle-notch ph-spin" aria-hidden="true" />
              <span>Loading categories...</span>
            </div>
          ) : subCategoriesError ? (
            <div className="mobile-menu-drawer__submenu-state">
              <i className="ph ph-warning-circle" aria-hidden="true" />
              <span>{subCategoriesError}</span>
              <button
                type="button"
                className="mobile-menu-drawer__submenu-retry"
                onClick={fetchSubCategories}
              >
                Retry
              </button>
            </div>
          ) : subCategories.length === 0 ? (
            <div className="mobile-menu-drawer__submenu-state">
              <i className="ph ph-squares-four" aria-hidden="true" />
              <span>No categories available</span>
            </div>
          ) : (
            subCategories.map((category) => (
              <Link
                key={category.id}
                to={`/collections/sub-category/${category.slug}`}
                className="mobile-menu-drawer__submenu-link"
                onClick={closeDrawer}
              >
                <span className="d-flex align-items-center gap-10 overflow-hidden">
                  {category.category_image && (
                    <img
                      src={category.category_image}
                      alt=""
                      className="flex-shrink-0"
                      style={{
                        width: "30px",
                        height: "30px",
                        borderRadius: "8px",
                        objectFit: "cover",
                      }}
                    />
                  )}
                  <span className="text-truncate">{category.name}</span>
                </span>
                <small>{category.products_count ?? 0}</small>
              </Link>
            ))
          )}
        </div>
      ) : (
        <>
          <div className="mobile-menu-drawer__submenu-list">
            {staticProfileOptions?.map((item) =>
              item?.label === "Logout" ? (
                <span
                  key={item.id}
                  className="mobile-menu-drawer__profile-link"
                  onClick={() => {
                    setShowLogoutModal(true);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <i className={item.icon} aria-hidden="true" />
                  <span>{item.label}</span>
                </span>
              ) : (
                <Link
                  key={item.id}
                  to={item.to}
                  className="mobile-menu-drawer__submenu-link"
                  onClick={closeDrawer}
                >
                  <span className="d-flex align-items-center gap-10 overflow-hidden">
                    <i className={item.icon} aria-hidden="true" />
                    <span className="text-truncate">{item.label}</span>
                  </span>
                </Link>
                //   <NavLink
                //     key={item.id}
                //     to={item.to}
                //     className={({ isActive }) =>
                //       `mobile-menu-drawer__profile-link${
                //         isActive ? " is-active" : ""
                //       }`
                //     }
                //   >
                //     <i className={item.icon} aria-hidden="true" />
                //     <span>{item.label}</span>
                //   </NavLink>
              ),
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default SubDrawer;
